import { FeatureFlag } from '../FeatureFlagService';
/*
  Tracks which usersnap projects are enabled for a certain route and/or feature flag

  example:

  '435e66db-fc6f-4c5a-97e5-8d5f8f34276b': {
    route: /settings\.php#cloudplatforms/,
    featureFlag: 'core.enable-teamleader-cloud-platform-customisation',
  },
*/

export const MULTIPLE_DEAL_PIPELINES = '82c4edd3-c73d-4032-ba5e-730a47803676';
export const NEXTGEN_PROJECTS = '36f7a5bf-2862-44d7-b073-06fedf74fe7c';

export const PROJECTS = {
  [MULTIPLE_DEAL_PIPELINES]: {
    route:
      /^\/settings.php#nav_sales|^\/settings.php\?manage_pipelines=1#nav_sales|^\/sales.php|^\/web\/deals\/pipeline.*/,
  },
  [NEXTGEN_PROJECTS]: { route: /^\/projects(?:\/[^.]+)?$/, featureFlag: FeatureFlag.ProjectsUsersnap },
};

export const EVENTS = {
  weeklyTimeTrackingModalOpened: 'weekly_time_tracking_modal_opened',
  remainOnOldProjects: 'remain-on-old-projects',
};
